export const EntityFilterType = {
    Association: 'association',
    Shipper: 'shipper',
    Network: 'network'
};
